/**
 * We also watch for "ui-draggable" style class, and add a "isBeingDragged" class
 * when it starts to be drug and remove the class when the drag ends.
 */

import ElementAndSubtreeObserver from "../../../scripts/ElementAndSubtreeObserver";

if ((window as any).jQuery === undefined) {
	// This should never happen
	throw new Error(`Component failed to register: Can not find instance of jQuery.`);
}
const jQuery = (window as any).jQuery;

const observer = ElementAndSubtreeObserver.getInstance();

observer.onElementWithStyleClass(
	"ui-draggable",
	(elem: Element) => { // on add
		if (elem.classList.contains("ui-draggable-helper")) {
			// The helper is a clone of a draggable element shown for dragging.
			return;
		}
		const $elem = jQuery(elem);
		$elem.on("dragstart", (ev: any, ui: any) => {
			if (ui !== undefined && ui.helper !== undefined) {
				ui.helper.addClass("ui-draggable-helper");

				const elemBoundingCR = elem.getBoundingClientRect();

				const optTreeNodeLabel = elem.querySelector(".ui-treenode-label-text"); // Remember, not all drags are in the tree.
				if (optTreeNodeLabel !== null) {
					const labelElemBoundingCR = optTreeNodeLabel.getBoundingClientRect();
					ui.helper.css("width", Math.round(labelElemBoundingCR.width) + "px");
					ui.helper.css("min-height", Math.round(labelElemBoundingCR.height) + "px");
					const translateX = Math.round(labelElemBoundingCR.left - elemBoundingCR.left);
					ui.helper.css("transform", `translateX(${translateX}px)`);
				} else {
					ui.helper.css("width", Math.round(elemBoundingCR.width) + "px");
					ui.helper.css("min-height", Math.round(elemBoundingCR.height) + "px");
				}
			}
		});

		// Client found with "Zoom Info - Reach Out B2B Contact & Company Info" (https://chrome.google.com/webstore/detail/zoominfo-reachout-b2b-con/fofjcndophjadilglgimelemjkjblgpf)
		// installed you get the following error in the console for the two draggable(..) calls below. The solution was to add $elem.draggable();
		// I am unsure what ZoomInfo is doing. e.g. are they loading a conficting version of jquery? Or are they just modifying the DOM before other things in Core are initialized?
		// The console error is: Uncaught Error: cannot call methods on draggable prior to initialization; attempted to call method 'option'
		$elem.draggable();

		$elem.draggable("option", "iframeFix", true); // When set to true, transparent overlays will be placed over all iframes on the page.

		// TODO The "distance" option is deprecated in version 1.12 of JQuery UI, but for now it provides a way to stop accidental drags. See https://jqueryui.com/upgrade-guide/1.12/#deprecated-distance-and-delay-options
		$elem.draggable("option", "distance", 5);

		let dragHelperAppendTo: JQuery<Element> = $elem.parents(".dialog");
		if (dragHelperAppendTo.length !== 1) {
			dragHelperAppendTo = jQuery(document.body);
		}
		$elem.draggable("option", "appendTo", dragHelperAppendTo);

		$elem.on("dragstart", onDragStart);
		$elem.on("dragstop", onDragStop);
	}
);

function onDragStart(event: any, {}: any) { // event: any, ui: any
	const itemBeingDragged = event.target;
	if (itemBeingDragged instanceof Element) {
		(itemBeingDragged as Element).classList.add("isBeingDragged");
	}
}
function onDragStop(event: any, {}: any) { // event: any, ui: any
	const itemBeingDragged = event.target;
	if (itemBeingDragged instanceof Element) {
		(itemBeingDragged as Element).classList.remove("isBeingDragged");
	}
}
